import React, { useState, useEffect } from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import RightFooter from "../common/RightFooter";
import t from "../../Utils/Translation";
import Tooltip from '@mui/material/Tooltip';
import LykioButton from "../common/LykioButton";
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom";
import MultiActionAreaCard from "./MultiActionAreaCard";
import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig
} from '../../Utils/Constants';
import Loading from './../common/Loading';
import axios from 'axios';

const Interviews = () => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [unitUsage, setUnitUsage] = useState([]);

  useEffect(() => {
		const fetchUnitUsage = async () => {
			try {
				const { data } = await axios.post(`${AUTHORIZED_URL_PREFIX}${"/user/getResultsByType"}`,{type: 'Interview'}, AxiosConfig());
				setUnitUsage(data.unitUsage);
                console.log(data.unitUsage);
				setIsLoading(false);
				if (!data.success) {
					console.log('error')
				}
			} catch (error) {
				console.log(error);
			}
		};
		fetchUnitUsage();
		
	}, []);

  const navigate = useNavigate();

  return (
    <div className="lykioccs-main-content lykiocss-colloquio">
       {isLoading ? <Loading/> :
        <>
       <Container className="lykiocss-margin-top-5em">
        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #0051b4, #00b1d1)",textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'50em'}} className="lykiocss-center">
                    {t('Recruitment interviews require experience and concentration. Take part in this activity to improve your bias-free interviewing skills by talking to several virtual candidates. Choose which interview candidate, select the questions you consider most appropriate, analyze the answers and make your decision. Once the task finished, you will receive a detailed feedback that highlights where your communication is jeopardized by biases.')}
                </div>
        </Row>
       </Container>
       <Container className='lykiocss-margin-top-4em'>
        <Row >
            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
               height={'24em'} width={'22em'} t={t} text={t('Start')} duration={15} level={"basic"} title={t("Assess the availability for business trips and relocation").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={1} openInIframe={true} 
               cover={unitUsage.filter((item) => item.unitId==='c001').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL1-TRASFERTE+E+TRASFERIMENTI.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col__1.png"}
               comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
              height={'24em'} width={'22em'} t={t} text={t('Start')} duration={5} level={"basic"} title={t("Address the theme of disability").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={2} openInIframe={true} 
              cover={unitUsage.filter((item) => item.unitId==='c002').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL2-DISABILITA.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col__2.png"}
              comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
              height={'24em'} width={'22em'} t={t} text={t('Start')} duration={5} level={"basic"} title={t("Practice inclusive language").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={3} openInIframe={true} 
              cover={unitUsage.filter((item) => item.unitId==='c003').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL3-DISLESSIA.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col_3.jpg"}
              comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
              height={'24em'} width={'22em'} t={t} text={t('Start')} duration={5} level={"basic"} title={t("Navigate the topic of gender identity").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={4} openInIframe={true} 
              cover={unitUsage.filter((item) => item.unitId==='c004').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL4-LGBT.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col_4.jpg"}
              comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
              height={'24em'} width={'22em'} t={t} text={t('Start')} duration={8} level={"advanced"} title={t("Explore the topic of work-life balance").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={5} openInIframe={true} 
              cover={unitUsage.filter((item) => item.unitId==='c005').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL5-GENITORIALITA.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col_5.jpg"}
              comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
              height={'24em'} width={'22em'} t={t} text={t('Start')} duration={5} level={"advanced"} title={t("Identify the questions to avoid").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={6} openInIframe={true} 
              cover={unitUsage.filter((item) => item.unitId==='c006').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL6-DOMANDEDAEVITARE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col_6.jpg"}
              comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
              <MultiActionAreaCard completed={false}
              height={'24em'} width={'22em'} t={t} text={t('Start')} duration={8} level={"basic"} title={t("Share the guidelines of the corporate dresscode").toUpperCase()} interview={true} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" id={7} openInIframe={true} 
              cover={unitUsage.filter((item) => item.unitId==='c007').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/COL7-DRESSCODE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/col_7.jpg"}
              comingSoon={true}/>
            </Col>

            {/* <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} title={t('Clarify any ambiguous points on the resume/CV')} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/interviewCovers/pic5.png" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} title={t('Explore the candidate’s experience')} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/interviewCovers/pic1.jpg" comingSoon={true}/>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} title={t('Deepen the understanding of the contract and position')} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/interviewCovers/pic2.jpg" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} title={t('Investigate the candidate’s inadequacy')} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/interviewCovers/pic7.png" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} title={t('Explore the candidate’s motivation')} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/interviewCovers/pic3.jpg" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} title={t('Explore the candidate’s willingness to undergo a challenging relocation')} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/interviewCovers/pic4.jpg" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/locks/blue_lock.png" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#0051b4" lightBackgroundColor="#00b1d1" duration={'?'} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/locks/blue_lock.png" comingSoon={true}/>
            </Col> */}
        </Row>
       </Container>
       </>
}
      <RightFooter />
    </div>
  );
};

export default Interviews;